import { render, staticRenderFns } from "./PromotionTargetConditions.vue?vue&type=template&id=fad925f6&"
import script from "./PromotionTargetConditions.vue?vue&type=script&lang=ts&"
export * from "./PromotionTargetConditions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports